import {MAX_API_PAGINATION_PAGE_NUMBER_LIMIT} from '../../common/network/apiConstants';

const CATEGORY_LIST_PAGE_SIZE = 24;
const TOGGLED_CATEGORY_PAGINATION_PAGE_NUMBER_LIMIT = 50;
const STATIC_CATEGORY_PAGINATION_PAGE_NUMBER_LIMIT = MAX_API_PAGINATION_PAGE_NUMBER_LIMIT;

export {
  CATEGORY_LIST_PAGE_SIZE,
  TOGGLED_CATEGORY_PAGINATION_PAGE_NUMBER_LIMIT,
  STATIC_CATEGORY_PAGINATION_PAGE_NUMBER_LIMIT,
};
